const message = {
  msg_1: 'Contact us',
  msg_2: 'News',
  msg_3: `Join us`,
  msg_4: 'About Huizhi',
  msg_5: 'Technology',
}

export default message